import React from 'react'
import  styled  from 'styled-components'
import { categories } from '../data'
import CategItems from './CategItems'
import {mobile} from "../responses"

const Container=styled.div`
    margin:0;
    ${mobile({padding:"0",flexDirection:"column",height:"100vh"})};
    display:flex;
    padding:10px;
    justify-content:space-between;
`


const Categories = () => {
  return (
    <Container id='catagories'>
       {categories.map(item=>{
            return (
                <CategItems key={item.id} item={item}/>
            )
        })
        }
    </Container>
  )
}

export default Categories
